<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :has-form="true" title="报告列表"
      width="50%" class="my-test-class" @cancel="closeShow" @confirm="handleConfirm" top="14vh">
      <div style="width: 100%;height: 500px;">
        <div style="width: 100%;display: flex;justify-content: flex-start;align-items: center;">
          <span style="font-size: 12px;margin-right: 20px;">选择日期</span>
          <gs-date-picker v-model="timeValue" type="date" placeholder="选择日期" style="margin-right: 12px;">
          </gs-date-picker>
          <span class="se-tit" @click="searchData">查询</span>
        </div>
        <el-table size='mini' :data="tableData"
          :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
          style="width: 100%;margin-top:15px" height="440px">
          <el-table-column prop="name" label="创建者" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <span style="color: #FF9502;cursor: pointer;font-size: 12px;"
                @click="showDesc(scope.row.timeAndRuleNames)">详情</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </gs-modal>
    <gs-modal v-loading="loadingdevice" v-model="visibleDecice" :before-close="beforeDeviceClose" :has-form="true"
      title="规则执行列表" width="50%" class="my-test-class" @cancel="closeDeviceShow" @confirm="handleConfirmDevice"
      top="14vh">
      <div style="width: 100%;height: 485px;">
        <el-table size='mini' :data="deviceArray"
          :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
          style="width: 100%;margin-top:15px" height="440px">
          <el-table-column prop="timeAndRuleName" label="名称" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <span style="color: #FF9502;cursor: pointer;font-size: 12px;" @click="shoRule(scope.row.args)">详情</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </gs-modal>

    <gs-modal v-model="ruleShow" :before-close="ruleShowClose" :has-form="true" title="执行数据列表" width="70%"
      class="my-test-class" @cancel="ruleShowClose" @confirm="ruleShowClose" top="14vh">
      <div style="width: 100%;height: 485px;">
        <el-table size='mini' :data="ruleArray"
          :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
          style="width: 100%;margin-top:15px" height="440px">
          <el-table-column prop="sn" label="sn" align="center" width="80">
          </el-table-column>
          <el-table-column prop="fullName" label="路径" align="center">
          </el-table-column>
          <el-table-column prop="desc" label="描述" align="center" width="150">
          </el-table-column>
          <el-table-column prop="value" label="值" align="center" width="150">
          </el-table-column>
        </el-table>
      </div>
    </gs-modal>


  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import service from '../../service/leftService.js'
import moment from 'moment'
export default {
  data() {
    return {
      params: {
        pageSize: 5,
        pageNum: 1
      },
      tableData: [
      ],
      loading: false,
      visible: false,
      loadingdevice: false,
      visibleDecice: false,
      deviceArray: [],
      deviceShow: true,
      timeValue: "",
      ruleShow: false,
      ruleArray: []
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    handleConfirm() {
      this.visible = false
    },
    beforeClose() {
      this.visible = false
    },
    getData() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();
      const timeData = `${year}-${month}-${day}`;
      service.queryByData(timeData).then(res => {
        this.tableData = res.users
      })
    },
    closeShow() {

    },
    // 获取展示的数据
    getShowData() {
      this.visible = true
      this.getData()
    },
    showDesc(val) {
      val.length == 0 ? this.deviceShow = true : this.deviceShow = false
      this.visibleDecice = true
      this.deviceArray = val
    },
    beforeDeviceClose() {
      this.visibleDecice = false
    },
    closeDeviceShow() {
      this.visibleDecice = false
    },
    handleConfirmDevice() {
      this.visibleDecice = false
    },
    searchData() {
      let timeData = this.timeValue.format('YYYY-MM-DD')
      service.queryByData(timeData).then(res => {
        this.tableData = res.users
      })
    },
    ruleShowClose() {
      this.ruleShow = false
    },
    shoRule(val) {
      this.ruleArray = val
      this.ruleShow = true
    },
  }
}
</script>
<style lang='scss'>
.dev-line {
  width: 100%;
  padding: 5px 5px;
  margin-bottom: 5px;
  color: rgb(241, 64, 58);
  font-size: 13px;
  font-weight: 600;
}

.dev-blank {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.se-tit {
  font-size: 12px;
  color: #FF9502;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceList/reportList.vue